import reducers from "./reducers"
import { combineReducers } from "redux"
import { createBrowserHistory } from "history"
import { createStore, applyMiddleware, compose } from "redux"
import { connectRouter, routerMiddleware } from "connected-react-router"
import thunk from "redux-thunk"
import websocketMiddleware from "./websocketMiddleware"

const history = createBrowserHistory()
reducers.router = connectRouter(history)
let middleware = [thunk, websocketMiddleware, routerMiddleware(history)]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    connectRouter(history)(combineReducers(reducers)),
    composeEnhancers(applyMiddleware(...middleware))
)

export { store, history }
